<div class="input-group">
  <label
    class="input-label"
    [idOrDefault]="labelId"
    [attr.for]="inputId"
    [attr.aria-label]="label"
    *ngIf="label"
  >
    {{ label }}
    <span *ngIf="optional" class="input-optional-text">
      {{ optional }}
    </span>
  </label>
  <ng-container *ngIf="isMultipleSelection">
    <nibtravel-pills
      [pills]="selectedPills"
      (removed)="onOptionRemoved($event)"
    >
    </nibtravel-pills>
  </ng-container>
  <div class="input-field">
    <input
      [idOrDefault]="inputId"
      class="input-value"
      [type]="type"
      [name]="inputName"
      [disabled]="disabled"
      [attr.data-e2e]="e2eId"
      [attr.placeholder]="placeholder"
      [attr.aria-label]="ariaLabel"
      [attr.aria-labelledby]="ariaLabelledby"
      [attr.aria-describedby]="ariaDescribedby"
      [autocompleteHandler]="autocompleteHandler"
      [onSearchKeyChanged]="searchKeyChanged"
      [onFilteredOptionsPopulated]="filteredOptionsPopulated"
      [onSelectedOptionsChanged]="selectedOptionsChanged"
      (valueSelected)="onOptionSelected($event)"
      (optionsPanelClosed)="onOptionsPanelClose()"
      [popularCountrySuggestions]="popularCountrySuggestions"
      (input)="onInputChange($event.target.value)"
      (blur)="onBlur()"
      (focus)="onFocusHandler($event)"
      value="{{ searchKey }}"
      autocomplete="off"
    />
  </div>
  <nibtravel-autocomplete-handler #autocompleteHandler="autocompleteHandler">
    <ng-container *ngIf="filteredOptions">
      <nibtravel-autocomplete-option
        *ngFor="let option of filteredOptions; index as i"
        [text]="option.text"
        [value]="option.value"
        [index]="i"
        [idOrDefault]="inputId + '-option-' + i"
        [id]="option.id"
        tabindex="0"
        >{{ option.text }}
      </nibtravel-autocomplete-option>
      <div class="autocomplete-no-result" *ngIf="noResultsFound()">
        {{ noResultHints }}
      </div>
      <div class="autocomplete-search-hints" *ngIf="noSearchKey()">
        {{ searchHints }}
      </div>
    </ng-container>
  </nibtravel-autocomplete-handler>
  <nibtravel-validation
    [validations]="validations"
    [control]="ngControl.control"
    [host]="formComponent"
    [errorMessageOnFormGroup]="errorMessageOnFormGroup"
    (errorEmitter)="error.emit($event)"
    *ngIf="validations"
  ></nibtravel-validation>
</div>
